import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "widget-container" }

import { define } from "core-js/core/object";
import { DxHtmlEditor, DxToolbar, DxItem } from "devextreme-vue/html-editor";


export default /*#__PURE__*/_defineComponent({
  __name: 'RichTextBox',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const headerValues = [false, 1, 2, 3, 4, 5];

const model = _useModel(__props, "modelValue");


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(DxHtmlEditor), {
      modelValue: model.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DxToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(DxItem), { name: "undo" }),
            _createVNode(_unref(DxItem), { name: "redo" }),
            _createVNode(_unref(DxItem), {
              "accepted-values": headerValues,
              name: "header"
            }),
            _createVNode(_unref(DxItem), { name: "bold" }),
            _createVNode(_unref(DxItem), { name: "italic" }),
            _createVNode(_unref(DxItem), { name: "strike" }),
            _createVNode(_unref(DxItem), { name: "underline" }),
            _createVNode(_unref(DxItem), { name: "link" })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})